var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99998 1.26641C1.59497 1.26641 1.26665 1.59473 1.26665 1.99974V4.06641H4.06665V1.26641H1.99998ZM4.66665 0.0664062H1.99998C0.932233 0.0664062 0.0666504 0.931989 0.0666504 1.99974V4.66641V9.99974C0.0666504 11.0675 0.932233 11.9331 1.99998 11.9331H4.66665H9.99998C11.0677 11.9331 11.9333 11.0675 11.9333 9.99974V4.66641V1.99974C11.9333 0.931989 11.0677 0.0664062 9.99998 0.0664062H4.66665ZM5.26665 1.26641V4.06641H10.7333V1.99974C10.7333 1.59473 10.405 1.26641 9.99998 1.26641H5.26665ZM4.06665 5.26641H1.26665V9.99974C1.26665 10.4047 1.59497 10.7331 1.99998 10.7331H4.06665V5.26641ZM5.26665 10.7331V5.26641H10.7333V9.99974C10.7333 10.4047 10.405 10.7331 9.99998 10.7331H5.26665Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuTable);
export default __webpack_public_path__ + "static/media/a11ymenu_table.591d56192a11dce50853cf710c24e184.svg";
export { ForwardRef as ReactComponent };